// use3DHoverEffect.js

import { animate, useMotionValue, useTransform } from 'framer-motion';

const use3DHover = ({
  perspectiveRange = [1000, 500],
  rotateRangeX = [-25, 25],
  rotateRangeY = [-25, 25],
  scaleRange = [1.3, 1.1],
  depthRange = [0, 30],
  shadowRange = ["0px 20px 40px rgba(0, 0, 0, 0.6)", "0px 0px 0px rgba(0, 0, 0, 0)"],
} = {}) => {
  const x = useMotionValue(0);
  const y = useMotionValue(0);

  const perspective = useTransform(y, [0, 400], perspectiveRange);
  const rotateY = useTransform(x, [-200, 200], rotateRangeY);
  const rotateX = useTransform(y, [-200, 200], rotateRangeX);
  const scaleImage = useTransform(y, [-200, 200], scaleRange);
  const yPositionImage = useTransform(y, [-200, 200], [-10, 10]);
  const zPositionImage = useTransform(y, [-200, 200], depthRange);
  const shadowImage = useTransform(y, [-200, 200], shadowRange);

  const handleMouseEnter = (event) => {
    const { clientX, clientY } = event;
    const { innerWidth, innerHeight } = window;
    const targetX = clientX - innerWidth / 2;
    const targetY = clientY - innerHeight / 2;

    animate(x, targetX, { type: "spring", stiffness: 150, damping: 20, duration: 0.3 });
    animate(y, targetY, { type: "spring", stiffness: 150, damping: 20, duration: 0.3 });
  };

  const handleMouseMove = (event) => {
    const { clientX, clientY } = event;
    const { innerWidth, innerHeight } = window;
    x.set(clientX - innerWidth / 2);
    y.set(clientY - innerHeight / 2);
  };

  const handleMouseLeave = () => {
    animate(x, 0, { type: "spring", stiffness: 300, damping: 25 });
    animate(y, 0, { type: "spring", stiffness: 300, damping: 25 });
  };

  return {
    perspective,
    rotateY,
    rotateX,
    scaleImage,
    yPositionImage,
    zPositionImage,
    shadowImage,
    handleMouseEnter,
    handleMouseMove,
    handleMouseLeave,
  };
};

export default use3DHover;
